import React from 'react';
import styled from '@emotion/styled';
import { FixedGridItem, Gutter, RadioButton, Row } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { DetailsFormSection as Section } from '../DetailsFormSection';
import { useDetailsFormContext } from '../hooks/useDetailsFormContext';
import { ReasonForTravel } from '../../../../domain/booking/models/ITravelDetails';
import Responsive from '../../../../../../ui/utils/Responsive';

export interface ITravelDetailsFormData {
	reasonForTravel: ReasonForTravel;
}
// This component now is in shared folder because it's used by account feature as well.
// This component has to be replaced with the reusable one.
export const TravelDetails = () => {
	const { t } = useTranslation();
	const { register } = useDetailsFormContext();

	return (
		<Section title={t('parking_personal_details_travel_details_title')}>
			<ReasonForTravelRow>
				<RadioButton
					value={ReasonForTravel.Business}
					label={t('parking_personal_details_travel_business')}
					{...register('reasonForTravel')}
				/>
				<RadioButton
					value={ReasonForTravel.Leisure}
					label={t('parking_personal_details_travel_leisure')}
					{...register('reasonForTravel')}
				/>
			</ReasonForTravelRow>
		</Section>
	);
};

const ReasonForTravelRow = styled(Row)`
	${FixedGridItem} {
		width: auto;
		${Gutter.cssVariableName.horizontal}: 40px;

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			${Gutter.cssVariableName.horizontal}: 24px;
		}
	}
`;
